import React from 'react';
import { useNavigate } from 'react-router-dom';
import { WSP_FF1_SKILL_SHEETS } from '../data/skillSheets';

const SkillSheetsList: React.FC = () => {
    const navigate = useNavigate();

    const handleViewSkillSheet = (skillSheetNumber: number) => {
        navigate(`/skill-sheets/${skillSheetNumber}`);
    };

    return (
        <div className="content-container">
            <div className="glass-header">
                <div>
                    <h1 className="text-title-xl">🧑‍🚒 WSP Firefighting Skill Sheets</h1>
                    <p className="text-body-lg">NFPA 1001 Firefighter I Certification Skill Sheets</p>
                </div>
                <div className="dashboard-overview">
                    <div className="content-stat">
                        <span className="content-stat-number large">{WSP_FF1_SKILL_SHEETS.length}</span>
                        <span className="content-stat-label">Skill Sheets</span>
                    </div>
                </div>
            </div>

            <div className="content-section">
                <h2 className="text-title-lg">All Skill Sheets</h2>
                <div className="content-grid content-grid-large">
                    {WSP_FF1_SKILL_SHEETS.map((skillSheet) => (
                        <div key={skillSheet.skill_sheet_number} className="content-card">
                            <h3 className="text-title-md">
                                Skill Sheet {skillSheet.skill_sheet_number}: {skillSheet.skill_area}
                            </h3>
                            <div className="text-caption" style={{margin: 'var(--spacing-sm) 0'}}>
                                JPR: {skillSheet.jpr}
                            </div>
                            <div style={{ display: 'flex', gap: 'var(--spacing-sm)', marginTop: 'var(--spacing-md)' }}>
                                <button 
                                    onClick={() => handleViewSkillSheet(skillSheet.skill_sheet_number)}
                                    className="btn btn-primary"
                                >
                                    View Skill Sheet {skillSheet.skill_sheet_number}
                                </button>
                                <button 
                                    onClick={() => navigate(`/skill-sheets/${skillSheet.skill_sheet_number}/flip-chart`)}
                                    className="btn btn-secondary"
                                >
                                    Flip Chart {skillSheet.skill_sheet_number}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SkillSheetsList;